// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_Xx-","cls2":"CiterightInline-cls2_U38 CiterightInline-cls1_Xx-"};